import { welcomeKitData } from "../../program.data";
import { ProgramWelcomeKit } from "./ProgramWelcomeKit";
import { useProgram } from "../../ProgramContext";

export function ProgramWelcomeKitContainer() {
  const { organization } = useProgram();

  const data = {
    ...welcomeKitData,
    captions: welcomeKitData.captions.map((caption) => ({
      text: caption.text.replace(
        "{{organization.name}}",
        organization?.name || "your organization"
      ),
    })),
  };

  return (
    <ProgramWelcomeKit
      data={data}
      title="Social Media Kit"
      description="Welcome to the Pollinator program."
    />
  );
}

export default ProgramWelcomeKitContainer;
